import type { TEvent } from '../models';
import { getAlwaysArray } from '../helpers/get-always-array';

import { prepareData } from './prepare-data';

export const prepareYmData = (
    applyTemplate: (template: string) => string,
    ymData: Required<TEvent>['ymData']
) => {
    const data = getAlwaysArray(ymData);

    return data.map(event => {
        const { params } = event;

        const eventParams = getAlwaysArray(params);
        const preparedEventParams = eventParams.map(param => {
            if (typeof param === 'string') return applyTemplate(param);

            return prepareData<Record<string, string | number>, string | number>(
                applyTemplate,
                param
            );
        });

        const preparedParams = Array.isArray(params) ? preparedEventParams : preparedEventParams[0];

        return { ...event, params: preparedParams };
    });
};
